import { render, staticRenderFns } from "./PageAuthCallback.vue?vue&type=template&id=dd060c42&scoped=true&"
import script from "./PageAuthCallback.vue?vue&type=script&lang=js&"
export * from "./PageAuthCallback.vue?vue&type=script&lang=js&"
import style0 from "./PageAuthCallback.vue?vue&type=style&index=0&id=dd060c42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd060c42",
  null
  
)

export default component.exports